import { Component, Vue } from 'vue-property-decorator';
import { getUserScrapAgentStorage, isUltraUser } from '@/util/paid-user-util';
import { UserScrapAgentStorage } from '@/shared/model/payment.model';

@Component({
  computed: {},
  methods: { isUltraUser },
  components: {},
})
export default class UserScrapAgent extends Vue {
  localStorageUser = JSON.parse(localStorage.getItem('localStorageUser')) || null;
  scrapAgentStorage = new UserScrapAgentStorage();

  mounted() {
    if (this.localStorageUser) {
      const { policyUsers } = this.localStorageUser;
      if (policyUsers) {
        for (const paidInfo of policyUsers) {
          if (UserScrapAgentStorage.featureIdx == paidInfo.featureIdx) {
            this.scrapAgentStorage = getUserScrapAgentStorage(paidInfo);
          }
        }
      }
    }
  }

  goTo(destination: string) {
    this.$router.push(destination);
  }
}
